import React from "react"

import { useFloorFragment } from "entities/floors/model/useFloorFragment"

import { DeleteFloorOverlayPayload } from "./DeleteFloorOverlayConnector"
import { DeleteFloorOverlayView } from "./DeleteFloorOverlayView"
import { useDeleteFloorOverlayViewModel } from "./model/useDeleteFloorOverlayViewModel"

export interface DeleteFloorOverlayModel {
  floor: ReturnType<typeof useFloorFragment>
  onDelete: () => void
  onClose: () => void
  payload: DeleteFloorOverlayPayload
}

export const DeleteFloorOverlay = React.memo(
  (props: DeleteFloorOverlayModel) => (
    <DeleteFloorOverlayView {...useDeleteFloorOverlayViewModel(props)} />
  )
)
